import React, { useEffect, useState } from 'react';
import { XMLParser } from 'fast-xml-parser';
function TableView() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [error, setError] = useState(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${baseURL}/api/orders-qoutes`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
        
                // Fetch design details and image for each item
                const enrichedData = await Promise.all(
                    result.map(async (item) => {
                        let designDetails = {};
                        let imageDetails = {};
        
                        // Fetch design details
                        if (item.did) {
                            try {
                                const detailResponse = await fetch(`${baseURL}/api/design-fetch-did`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({ did: item.did }),
                                });
        
                                if (detailResponse.ok) {
                                    const details = await detailResponse.json();
                                    designDetails = details.length > 0 ? details[0] : {};
                                }
                            } catch (detailError) {
                                console.error(`Error fetching design details for did ${item.did}:`, detailError);
                            }
                        }
        
                        // Fetch image details
                        if (item.imageId) {
                            try {
                                const imageResponse = await fetch(`${baseURL}/api/image-details/${item.imageId}?currency=INR`);
                                const xmlText = await imageResponse.text();
                                const parser = new XMLParser({ ignoreAttributes: false });
                                const parsedData = parser.parse(xmlText);
        
                                const imageNode = parsedData?.rsp?.image;
                                if (imageNode) {
                                    imageDetails = {
                                        id: imageNode['@_id'],
                                        description: imageNode.description,
                                        contributor: imageNode.contributor['@_id'],
                                        filename: imageNode['@_filename'],
                                        folder: imageNode['@_folder'],
                                        src: `http://images.assetsdelivery.com/thumbnails/${imageNode.contributor['@_id']}/${imageNode['@_folder']}/${imageNode['@_filename']}.jpg`,
                                        sizes: Array.isArray(imageNode.sizes.size)
                                            ? imageNode.sizes.size.map(size => ({
                                                label: size['@_label'],
                                                width: size['@_width'],
                                                height: size['@_height'],
                                                price: size['@_price'],
                                                format: size['@_format'],
                                            }))
                                            : [],
                                    };
                                }
                            } catch (imageError) {
                                console.error(`Error fetching image details for imageId ${item.imageId}:`, imageError);
                            }
                        }
        
                        return {
                            ...item,
                            designName: designDetails.dname || '',
                            designImage: designDetails.image || '',
                            designDescription: designDetails.ds1 || '',
                            imageSrc: imageDetails.src || '',
                            imageDescription: imageDetails.description || '',
                        };
                    })
                );
        
                setData(enrichedData);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };
        
        fetchData();
        
        
    }, [baseURL]);

    const handleDownload = async (imageId) => {
        try {
            const response = await fetch(`${baseURL}/api/download/${imageId}`);
            if (!response.ok) {
                throw new Error('Failed to download image');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${imageId}.jpg`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            alert(`Download failed: ${error.message}`);
        }
    };
    const openModal = (imageId) => {
        setSelectedImageId(imageId);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedImageId(null);
    };

    if (loading) return <div>Loading data...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Table View</h2>
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Design</th>
                        <th>Reference</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact</th>
                       
                        <th>SIZE</th>
                        <th>PRICE</th>
                        <th>Specifications</th>
                        <th>CREATED AT</th>
                       
                        <th>ACTIONS</th>
                    </tr>
                </thead>
                <tbody>
    {data.map((item, index) => (
        <tr key={index}>
            <td>{item.order_id}</td>
            <td>
                {item.designImage ? (
                    <img 
                        src={`${baseURL}/images/${item.designImage}`} 
                        alt={item.designName} 
                        style={{ width: '100px', height: 'auto' }} 
                    />
                ) : (
                    <span>No Design Image</span>
                )}
                <p><strong>{item.designName}</strong></p>
                <p>{item.designDescription}</p>
            </td>
            <td>
            {item.imageId}
                {item.imageSrc ? (
                    <img 
                        src={item.imageSrc} 
                        alt={item.imageDescription} 
                        style={{ width: '100px', height: 'auto' }} 
                    />
                ) : (
                    <span>No Image</span>
                )}
                <p>{item.imageDescription}</p>
            </td>
            <td>{item.u_name}</td>
            <td>{item.email}</td>
            <td>{item.contact}</td>

            
            <td>{item.size}</td>
            <td>{item.price}</td>
            <td>{item.specification}</td>
            <td>{new Date(item.date).toLocaleString()}</td>
            <td>
            <button 
                                    className="btn btn-primary" 
                                    onClick={() => openModal(item.imageId)}
                                >
                                    Download
                                </button>
            </td>
        </tr>
    ))}
</tbody>
            </table>
            {/* Modal */}
{showModal && (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Confirm Download</h5>
                    <button 
                        type="button" 
                        className="btn-close" 
                        onClick={closeModal}
                    ></button>
                </div>
                <div className="modal-body">
                    <p>Are you sure you want to download this image?</p>
                </div>
                <div className="modal-footer">
                    <button 
                        className="btn btn-danger" 
                        onClick={closeModal}
                    >
                        No
                    </button>
                    <button 
                        className="btn btn-success" 
                        onClick={() => {
                            handleDownload(selectedImageId);
                            closeModal();
                        }}
                    >
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </div>
)}

        </div>
        
        
        
    );
   
}


export default TableView;



